import Immutable, { Record, OrderedMap, List, Map } from 'immutable';

export const KET_EXAM_TYPE_MOCK = 'mock';
export const KET_EXAM_TYPE_REAL = 'real';

const KetSkillRecord = Record({
  skillId: undefined,
  name: undefined,
  maxMark: undefined,
  orderingSequence: undefined,
  markToScaleMappings: new List(), // List<Map{ mark, scale }>
});

export class KetSkill extends KetSkillRecord { }

KetSkill.create = (data) => new KetSkill(data).mapEntries(([key, val]) => {
  if (! val) return [key, val];
  switch (key) {
    case 'skillId':
      return [key, `${val}`]; // stringify
    case 'markToScaleMappings':
      return [key, Immutable.fromJS(val)];
    default:
      return [key, val];
  }
});

const KetStudentResultRecord = Record({
  studentId: undefined,
  status: undefined,
  // key: skillId, value: Map{ mark, scale, grade, level, markedBy, markedTime }
  skillResults: new Map(),
  finalScore: undefined,
  passType: undefined,
  cefrLevel: undefined,
  markedBy: undefined,
  markedTime: undefined,
});

export class KetStudentResult extends KetStudentResultRecord { }

KetStudentResult.create = (data) => new KetStudentResult(data).mapEntries(([key, val]) => {
  if (! val) return [key, val];
  switch (key) {
    case 'studentId':
      return [key, `${val}`]; // stringify
    case 'skillResults': {
      if (Map.isMap(val)) return [key, val];
      return [key, new Map(val.map((skillResult) =>
        [`${skillResult.skillId}`, Immutable.fromJS(skillResult)]))];
    }
    default:
      return [key, Immutable.fromJS(val)];
  }
});

const KetExamRecord = Record({
  ketExamId: undefined,
  groupId: undefined,
  examType: undefined, // 'mock' | 'real'
  mockIndex: undefined, // 1 | 2 (mock only)
  name: undefined,
  skills: new List(), // List<KetSkill>
  scaleBandings: new List(), // List<Map{ scaleFrom, scaleTo, grade, cefrLevel }>
  studentResults: new OrderedMap(), // key: studentId
});

class KetExam extends KetExamRecord { }

const reviver = ([key, val]) => {
  if (! val) return [key, val];
  switch (key) {
    case 'ketExamId':
    case 'groupId':
      return [key, `${val}`]; // stringify
    case 'skills':
      return [key, new List(val.map(KetSkill.create))];
    case 'scaleBandings':
      return [key, Immutable.fromJS(val)];
    case 'studentResults': {
      if (OrderedMap.isOrderedMap(val)) return [key, val];
      return [key, new OrderedMap(val.map((item) => {
        const studentResult = KetStudentResult.create(item);
        return [studentResult.studentId, studentResult];
      }))];
    }
    default:
      return [key, Immutable.fromJS(val)];
  }
};

KetExam.create = (data) => new KetExam(data).mapEntries(reviver);

export default KetExam;



// WEBPACK FOOTER //
// ./data/KetExams/model.js